import React from 'react'
import Button from '@mui/material/Button'
import { formatMoney } from '../../../utils/amount'
import { formatPercent, formatGatewayValue } from './helpers'

// Selected-payment counts per composite gateway value, e.g.
// "Mint · Maverick 5 · green.money 4 · Sola 2". Labels come from the summary's
// value->label map (derived from availableGateways), falling back to a composed label.
const formatGatewayBreakdown = (breakdown = {}, labels = {}) => {
  const entries = Object.entries(breakdown).filter(([, n]) => n > 0)
  if (!entries.length) return '—'
  return entries.map(([value, n]) => `${labels[value] || formatGatewayValue(value)} ${n}`).join(' · ')
}

const SummaryBar = ({ summary, totalRows, onProcess }) => {
  const { count, amount, avgForecast, gatewayBreakdown, gatewayLabels } = summary

  // Nothing to act on when there are no candidate rows — the table's empty
  // state carries the message instead, so we don't pin an empty action bar.
  if (!totalRows) return null

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-20 border-t border-divider bg-paper px-6 py-3 flex flex-wrap items-center gap-x-8 gap-y-2 shadow-[0_-4px_16px_rgba(0,0,0,0.06)]"
      data-testid="summary-bar"
    >
      <div>
        <p className="text-xs text-text-secondary">Selected</p>
        <p className="text-sm font-semibold text-text-primary" data-testid="summary-selected-count">
          {count} of {totalRows}
        </p>
      </div>
      <div>
        <p className="text-xs text-text-secondary">Selected Amount</p>
        <p className="text-sm font-semibold text-text-primary" data-testid="summary-selected-amount">
          {formatMoney(amount)}
        </p>
      </div>
      <div>
        <p className="text-xs text-text-secondary">AI Forecasted Success Rate</p>
        <p className="text-sm font-semibold text-info-main">{formatPercent(avgForecast)}</p>
      </div>
      <div>
        <p className="text-xs text-text-secondary">Gateway Breakdown</p>
        <p className="text-sm font-semibold text-text-primary" data-testid="summary-gateway-breakdown">
          {formatGatewayBreakdown(gatewayBreakdown, gatewayLabels)}
        </p>
      </div>
      <Button
        variant="contained"
        color="primary"
        size="large"
        className="ml-auto"
        data-testid="process-selected-btn"
        disabled={count === 0}
        onClick={onProcess}
      >
        {count === 0 ? 'Approve Selected Payments' : `Approve ${count} Payment${count === 1 ? '' : 's'}`}
      </Button>
    </div>
  )
}

export default SummaryBar
